import script from "./TokenAmounts.vue?vue&type=script&setup=true&lang=ts"
export * from "./TokenAmounts.vue?vue&type=script&setup=true&lang=ts"

import "./TokenAmounts.vue?vue&type=style&index=0&id=a63c73da&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a63c73da"]])

export default __exports__